import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div
      className={`
        bg-surface-card rounded-2xl p-5
        border border-border-subtle
        shadow-xs
        transition-shadow duration-200
        hover:shadow-sm
        ${className}
      `}
    >
      {children}
    </div>
  )
}
